import { useToast } from 'vuestic-ui'

const { notify } = useToast()

function info(msg) {
  notify({ message: msg, color: 'primary' })
}

function success(msg, duration) {
  notify({ message: msg, color: 'success', duration: duration })
}

function warn(msg, duration) {
  notify({ message: msg, color: 'warning', duration: duration })
}

function error(msg) {
  notify({ message: msg, color: 'danger' })
}

export default {
  info,
  success,
  warn,
  error,
}
